
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import zuzhi from "../../static/images/zuzhi.png"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'1'} />
        <AboutTitle name={'组织架构'} english={'ABOUT US'}  />
        <div className='aboutCoctent'>
          <img src={zuzhi} />
          <div style={{height:'60px'}}></div>
        </div>

      </PageBox>
    </>
  );
}
